import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureAccessService } from './feature-access.service';

/**
 * Route guard for a feature-allow-list key: waits for the signed-in person's keys, then lets them in or sends them to
 * the home page. UI gating only (see FeatureAccessService).
 *   { path: 'accuracy-analysis', canActivate: [AuthGuard, featureGuard('accuracy_analysis')], … }
 * A list lets in anyone with any of the keys.
 */
export function featureGuard(key: string | readonly string[]): CanActivateFn {
  return async () => {
    const features = inject(FeatureAccessService);
    const router = inject(Router);
    features.load();
    await features.ready;
    return features.hasAny(key) ? true : router.createUrlTree(['/']);
  };
}
